export default __webpack_public_path__ + "static/media/SWT1870.34I-40894_-24200_0.fe992cb0.jpg";